<template>
  <v-container fluid>
    <v-form class="pa-0" ref="form" v-model="validForm" lazy-validation>

      <v-col>
        <v-row>
          <h2 v-if="!$route.params.id" :class="$vuetify.theme.isDark ? 'white--text' : ''">
            Crear Corrida
          </h2>

          <h2 v-else :class="$vuetify.theme.isDark ? 'white--text' : ''">
            Editar Corrida
          </h2>

          <v-spacer></v-spacer>

          <v-btn
            :disabled="!validForm"
            :loading="previewLoading || saving"
            class="mx-1"
            elevation="0"
            color="primary"
            rounded
            @click="validateForm">
            Guardar
          </v-btn>

          <v-btn
            class="mx-1"
            elevation="0"
            color="error"
            rounded
            v-if="$route.params.id"
            @click="destroyDialog = true">
            Eliminar
          </v-btn>
        </v-row>
      </v-col>

      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title class="pb-2">
              <h4 :class="$vuetify.theme.isDark ? 'white--text' : ''">
                <v-icon :color="$vuetify.theme.isDark ? 'white' : 'secondary'">mdi-clipboard-text</v-icon>
                Descripción
              </h4>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field :rules="emptyRule" hide-details dense outlined v-model="payload.name" label="Nombre">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="px-6 py-0">
                  <v-row align="center" justify="center">
                    <h4 class="mb-0 pr-3" :class="$vuetify.theme.isDark ? 'white--text' : ''">Activo:</h4>
                    <v-switch :color="$vuetify.theme.isDark ? 'primary' : 'secondary'" v-model="payload.enabled">
                    </v-switch>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card>
            <v-card-title class="pb-2">
              <v-row justify="space-between" align="center">
                <v-col cols="8">
                  <h4 class="mb-0" :class="$vuetify.theme.isDark ? 'white--text' : ''">
                    <v-icon :color="$vuetify.theme.isDark ? 'white' : 'secondary'">mdi-clipboard-text</v-icon>
                    Items ({{ payload.items.length }})
                  </h4>
                </v-col>
                <v-btn @click="addChip" class="mx-4" fab small elevation="0" rounded color="primary">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
            </v-card-title>

            <v-card-text>
              <hr class="my-0">
              <v-col cols="12">
                <v-row justify="start" :key="row._uid" v-for="(row, index) in payload.items">
                  <v-col class="pb-0" md="6" lg="3" cols="6">
                    <v-text-field :rules="emptyRule" v-model="row.value" label="Talla"></v-text-field>
                  </v-col>

                  <v-col class="pb-0" md="6" lg="3" cols="6">
                    <v-text-field label="Orden" :rules="emptyRule" v-model="row.order"></v-text-field>
                  </v-col>

                  <v-col>
                    <template v-if="payload.items.length > 1">
                      <v-btn @click="removeChip(index)" small icon>
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Diálogo de confirmación de impacto -->
      <v-dialog v-model="confirmDialog" max-width="480" persistent>
        <v-card>
          <v-card-title class="headline">Confirmar cambios</v-card-title>

          <v-card-text v-if="summary">
            <p class="mb-4">La corrida será aplicada a
              <strong>{{ summary.productos_afectados }}</strong> productos.
            </p>

            <v-simple-table dense>
              <tbody>
                <tr>
                  <td>Se crearán</td>
                  <td class="text-right"><strong>{{ summary.variantes_creadas }}</strong> variantes</td>
                </tr>
                <tr>
                  <td>Se actualizarán</td>
                  <td class="text-right"><strong>{{ summary.variantes_actualizadas }}</strong> variantes</td>
                </tr>
                <tr>
                  <td>Se eliminarán</td>
                  <td class="text-right"><strong>{{ summary.variantes_eliminadas }}</strong> variantes</td>
                </tr>
                <tr v-if="summary.variantes_con_stock">
                  <td>Con inventario (no se eliminan)</td>
                  <td class="text-right"><strong>{{ summary.variantes_con_stock }}</strong> variantes</td>
                </tr>
              </tbody>
            </v-simple-table>

            <!-- Desglose específico de incidencias (antes se mostraba solo un total ambiguo) -->
            <template v-if="summary.incidencias && summary.incidencias.length">
              <v-divider class="my-3"></v-divider>
              <p class="mb-2 warning--text">
                <v-icon small color="warning">mdi-alert</v-icon>
                <strong>Incidencias detectadas ({{ summary.incidencias.length }})</strong>
              </p>
              <ul class="pl-4 mb-0">
                <li v-for="(inc, i) in summary.incidencias" :key="i" class="mb-1">
                  {{ incidenciaTexto(inc) }}
                </li>
              </ul>
            </template>

            <p class="mt-4 mb-0">¿Desea continuar?</p>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" text :disabled="saving" @click="confirmDialog = false">
              Cancelar
            </v-btn>
            <v-btn elevation="0" class="pa-4" rounded color="primary" :loading="saving" @click="update">
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de eliminación -->
      <v-dialog v-model="destroyDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">¿Estas seguro?</v-card-title>
          <v-card-text>Una vez elimines el registro, no podrás recuperarlo.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" text @click="destroyDialog = false">Mejor no</v-btn>
            <v-btn elevation="0" class="pa-4" rounded color="error" @click="destroy">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-form>
  </v-container>
</template>

<script>
let item_order = 1
let uid = 0 // llave única y estable por fila (independiente del orden que edita el usuario)

export default {
  data() {
    return {
      destroyDialog: false,
      confirmDialog: false,
      validForm: true,
      previewLoading: false,
      saving: false,
      summary: null,
      emptyRule: [v => !!v || 'Necesario'],
      payload: {
        id: null,
        name: null,
        enabled: true,
        items: [{ _uid: uid++, order: 1, value: null }]
      }
    }
  },

  methods: {
    addChip() {
      item_order++
      this.payload.items.unshift({ _uid: uid++, value: '', order: item_order })
    },

    removeChip(index) {
      this.payload.items.splice(index, 1)
    },

    // Quita campos que solo existen en el cliente (p.ej. _uid) antes de enviar al backend.
    cleanItems() {
      return this.payload.items.map((it) => {
        const copy = { ...it }
        delete copy._uid
        return copy
      })
    },

    validateForm() {
      if (!this.$refs.form.validate()) return

      // Al crear no hay productos que sincronizar: guardar directo.
      if (this.$route.params.id) {
        this.requestPreview()
      } else {
        this.store()
      }
    },

    // Etapa API: calcula el impacto sin guardar y decide si pedir confirmación.
    requestPreview() {
      this.previewLoading = true

      this.$axios
        .post(`/admin/size-collections/${this.$route.params.id}/preview`, {
          items: this.cleanItems()
        })
        .then((response) => {
          this.summary = response.data.summary

          // Si nada cambia en los productos, no molestamos con el diálogo.
          const s = this.summary
          const nothingToConfirm =
            !s.productos_afectados ||
            (!s.variantes_creadas && !s.variantes_actualizadas &&
             !s.variantes_eliminadas && !s.inconsistencias)

          if (nothingToConfirm) {
            this.update()
          } else {
            this.confirmDialog = true
          }
        })
        .catch((error) => console.log(error))
        .finally(() => { this.previewLoading = false })
    },

    // Traduce cada incidencia del backend a un mensaje específico para el usuario.
    incidenciaTexto(inc) {
      switch (inc.tipo) {
        case 'productos_sin_variantes':
          return `${inc.cantidad} producto(s) de esta corrida no tienen ninguna variante registrada.`
        case 'variantes_duplicadas':
          return `${inc.cantidad} variante(s) con talla repetida dentro de un mismo producto, en ${inc.productos} producto(s).`
        case 'talla_ya_existente':
          return `La talla "${inc.talla}" ya existía en ${inc.cantidad} producto(s); no se volverá a crear.`
        case 'colision_al_renombrar':
          return `Al renombrar "${inc.de}" → "${inc.a}", ${inc.productos} producto(s) ya tenían la talla destino; no se renombran para evitar duplicados.`
        case 'talla_eliminada_con_inventario':
          return `La talla "${inc.talla}" tiene inventario en ${inc.cantidad} variante(s); no se eliminará.`
        default:
          return inc.tipo
      }
    },

    edit() {
      this.$axios
        .get(`/admin/size-collections/${this.$route.params.id}/edit`)
        .then((response) => {
          const data = response.data.item
          // Se ordena por "order" UNA sola vez al cargar y se asigna una llave
          // estable a cada fila. Así el usuario ve las tallas ordenadas al abrir,
          // pero editar el campo "Orden" ya no reacomoda las filas mientras escribe.
          data.items = (data.items || [])
            .slice()
            .sort((a, b) => a.order - b.order)
            .map((it) => ({ ...it, _uid: uid++ }))
          this.payload = data
        })
    },

    store() {
      this.saving = true
      this.$axios
        .post('/admin/size-collections', { ...this.payload, items: this.cleanItems() })
        .then((response) => {
          this.$store.commit('OPEN_SNACKBAR', response.data)
          if (response.data.success) this.$router.push('/size-collections')
        })
        .catch((error) => console.log(error))
        .finally(() => { this.saving = false })
    },

    update() {
      this.saving = true
      // Laravel put workaround + items saneados (sin _uid, campo solo del cliente).
      const body = { ...this.payload, items: this.cleanItems(), _method: 'PUT' }

      this.$axios
        .post(`/admin/size-collections/${this.$route.params.id}`, body)
        .then((response) => {
          this.$store.commit('OPEN_SNACKBAR', response.data)
          if (response.data.success) this.$router.push('/size-collections')
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.saving = false
          this.confirmDialog = false
        })
    },

    destroy() {
      const formData = new FormData()
      formData.append('_method', 'DELETE') // Laravel delete workaround

      this.$axios
        .post(`/admin/size-collections/${this.$route.params.id}`, formData)
        .then((response) => {
          this.$store.commit('OPEN_SNACKBAR', response.data)
          if (response.data.success) this.$router.push('/size-collections')
        })
        .catch((error) => console.log(error))
    }
  },

  mounted() {
    if (this.$route.params.id) this.edit()
  }
}
</script>
